import { createContext, useContext } from 'react';

export const FormFieldContext = createContext<string | null>(null);

export function useFormFieldName(): string {
  const name = useContext(FormFieldContext);
  if (!name) throw new Error('<FormItem> must sit inside <FormField>');
  return name;
}
